import types from '../types'
import api from '@/pages/comet/api'

const initCourse = {
  video_id: null
}
const state = {
  replies: {},
  course: initCourse
}

const getters = {
  replies: state => state.replies || [],
  course: state => state.course || initCourse
}

const mutations = {
  [types.CHANGE_COURSE] (state, { course }) {
    state.course = course || initCourse
  }
}
const actions = {
  getCourse ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.videoGetCourse(payload).then(res => {
        commit(types.CHANGE_COURSE, {
          course: res.data.data || initCourse
        })
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  },
  clearCourse ({ commit }) {
    commit(types.CHANGE_COURSE, {
      course: initCourse
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
